<p-dialog
  [visible]="visible()" (onHide)="hideDialog()"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  styleClass="w-11 md:w-8 lg:w-6 xl:w-5"
  [header]="'POS.MEMBERSHIP_ADDON.PRODUCT_FULFILLMENT' | translate"
  (onHide)="onCancel()"
  [attr.aria-label]="'product-fulfillment-dialog'"
  [attr.data-testid]="'product-fulfillment-dialog'">

  <div class="product-fulfillment-content">
    <!-- Header Info -->
    <div class="mb-2 p-2 bg-blue-50 border-round">
      <div class="flex align-items-center gap-2 mb-1">
        <i class="fa fa-info-circle text-blue-600 text-sm"></i>
        <span class="font-medium text-blue-900 text-sm">
          {{ 'POS.MEMBERSHIP_ADDON.FULFILLMENT_INFO' | translate }}
        </span>
      </div>
      <p class="text-xs text-blue-800 m-0 line-height-3">
        {{ 'POS.MEMBERSHIP_ADDON.FULFILLMENT_DESCRIPTION' | translate }}
      </p>
    </div>

    <!-- Products List -->
    <div class="products-list max-h-20rem overflow-y-auto">
      @for (product of localProducts; track trackBySkuId($index, product)) {
        <div
          class="product-item p-2 border-1 border-200 border-round mb-2 hover:bg-surface-50 transition-colors">
          <div class="flex align-items-center gap-2">
            <!-- Product Image -->
            <div class="product-image flex-shrink-0">
              @if (shouldShowImage(product)) {
                <div class="w-2rem h-2rem border-round overflow-hidden border-1 border-200">
                  <img
                    [src]="getProductImage(product)"
                    [alt]="getProductName(product)"
                    class="w-full h-full object-fit-cover"
                    (error)="onImageError(product)">
                  </div>
                } @else {
                  <div class="w-2rem h-2rem bg-surface-100 border-round flex align-items-center justify-content-center border-1 border-200">
                    <i class="fa fa-cube text-surface-400 text-xs"></i>
                  </div>
                }
              </div>
              <!-- Product Details -->
              <div class="product-details flex-1">
                <div class="flex justify-content-between align-items-start mb-1">
                  <div class="product-name font-medium text-900 text-sm line-height-2">
                    {{ getProductName(product) }}
                  </div>
                  @if (product.is_plan_sku) {
                    <div class="ml-2">
                      <span class="inline-block px-1 py-0 bg-green-100 text-green-800 text-xs border-round font-medium">
                        <i class="fa fa-tag mr-1"></i>
                        {{ 'POS.MEMBERSHIP_ADDON.PLAN_SKU' | translate }}
                      </span>
                    </div>
                  }
                </div>
                <div class="flex flex-column gap-2">
                  <div class="product-info flex flex-wrap align-items-center gap-2 text-xs text-600">
                    <span class="flex align-items-center gap-1">
                      <i class="fa fa-barcode text-xs"></i>
                      {{ product.sku_id }}
                    </span>
                    <span class="flex align-items-center gap-1">
                      <i class="fa fa-cubes text-xs"></i>
                      {{ product.quantity }}
                    </span>
                    <span class="font-medium text-900">
                      {{ getProductPrice(product) | currencyformat }}
                    </span>
                  </div>
                  <!-- Fulfillment Toggle -->
                  <div class="fulfillment-toggle">
                    <div class="flex align-items-center gap-2">
                      <label class="text-xs font-medium text-700 white-space-nowrap">
                        {{ 'POS.MEMBERSHIP_ADDON.FULFILLED' | translate }}:
                      </label>
                      <p-togglebutton [(ngModel)]="product.is_fulfilled"
                        (ngModelChange)="onToggleFulfillment(product, $event)"
                        [onLabel]="'common.BUTTONS.BUTTON-TEXT-YES' | translate"
                        [offLabel]="'common.BUTTONS.BUTTON-TEXT-NO' | translate"
                        [onIcon]="'fa fa-check'"
                        [offIcon]="'fa fa-times'"
                        styleClass="w-5rem"
                        [attr.aria-label]="'fulfillment-toggle-' + product.sku_id"
                        [attr.data-testid]="'fulfillment-toggle-' + product.sku_id" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Summary -->
      <div class="fulfillment-summary mt-2 p-2 bg-surface-50 border-round border-left-3 border-primary">
        <div class="flex justify-content-between align-items-center">
          <span class="font-medium text-700 text-sm">
            {{ 'POS.MEMBERSHIP_ADDON.SUMMARY' | translate }}:
          </span>
          <div class="flex gap-3">
            <span class="text-xs">
              <i class="fa fa-check text-green-600 mr-1"></i>
              {{ getFulfilledCount() }} {{ 'POS.MEMBERSHIP_ADDON.FULFILLED' | translate }}
            </span>
            <span class="text-xs">
              <i class="fa fa-times text-red-600 mr-1"></i>
              {{ getPendingCount() }} {{ 'POS.MEMBERSHIP_ADDON.PENDING' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog Footer -->
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
          icon="fa fa-times"
          severity="secondary"
          styleClass="text-sm"
          (onClick)="onCancel()"
          [attr.aria-label]="'cancel-fulfillment'"
          [attr.data-testid]="'cancel-fulfillment'" />

        <p-button label="{{ 'common.BUTTONS.BTN_CONFIRM' | translate }}"
          icon="fa fa-check"
          styleClass="text-sm"
          (onClick)="onConfirm()"
          [attr.aria-label]="'confirm-fulfillment'"
          [attr.data-testid]="'confirm-fulfillment'" />
      </div>
    </ng-template>
  </p-dialog>
